import * as React from "react";
import PhoneInput from "react-phone-input-2";
import { formatterPhone } from "../../../helpers/Utils";

export const Telephone = ({ value, handleChange, disabled }) => {
	const handlePhone = (_value, _object, _event, valuePhone) => {
		handleChange(formatterPhone(valuePhone));
	};

	return (
		<PhoneInput
			autoFormat
			country="ru"
			onlyCountries={["ru"]}
			value={value}
			disabled={disabled}
			onChange={handlePhone}
		/>
	);
};
